// @flow
/** Liste des web-services disponibles pour l'api. */
export const ApiServices: StringEnum = {
  ERROR: 'poker/public/client/error'
};

export type ApiService = $Values<typeof ApiServices>;
